import { render, staticRenderFns } from "./reportNetsuiteThaiTax.vue?vue&type=template&id=84fb3e28&scoped=true"
import script from "./reportNetsuiteThaiTax.vue?vue&type=script&lang=js"
export * from "./reportNetsuiteThaiTax.vue?vue&type=script&lang=js"
import style0 from "./reportNetsuiteThaiTax.vue?vue&type=style&index=0&id=84fb3e28&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fb3e28",
  null
  
)

export default component.exports